import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        link: {
            margin: theme.spacing(1, 0.5),
        },
    }
})

export default useStyles
